export const RECEIPT_SUCCESS = "RECEIPT_SUCCESS";
